export const FETCH_CHECKOUTS = 'FETCH_CHECKOUTS';